import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import { TaskList } from "./pages/TaskList";
import { Simulator } from "./pages/Simulator";
import { Sandbox } from "./pages/Sandbox";
import { Profile } from "./pages/Profile";
import { Login } from "./pages/Login";
import { Landing } from "./pages/Landing";
import { Courses } from "./pages/Courses";
import { CoursePage } from "./pages/CoursePage";
import { LessonPage } from "./pages/LessonPage";
import { FAQ } from "./pages/FAQ";
import { TelegramAuth } from "./pages/TelegramAuth";
import { YandexAuthCallback } from "./pages/YandexAuthCallback";
import { DataDocs } from "./pages/DataDocs";
import { JobMarket } from "./pages/JobMarket";
import { AITutor } from "./pages/AITutor";
import { AITutorValidate } from "./pages/AITutorValidate";
import { CoursePreviewPage } from "./pages/CoursePreviewPage";
import { CorporatePage } from "./pages/CorporatePage";
import { ConsultingPage } from "./pages/ConsultingPage";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfService } from "./pages/TermsOfService";
import { UserProvider, useUser } from "./contexts/UserContext";

// На лендинге свой footer, на полноэкранных страницах footer не нужен
const FOOTER_HIDDEN_ON: string[] = ["/"];
const FOOTER_HIDDEN_PREFIXES = [
  "/task/",
  "/simulator",
  "/sandbox",
  "/ai-tutor",
  "/telegram-auth",
  "/auth/",
  "/courses",
];

function useShowFooter() {
  const location = useLocation();
  const path = location.pathname;
  if (FOOTER_HIDDEN_ON.includes(path)) return false;
  return !FOOTER_HIDDEN_PREFIXES.some((prefix) => path.startsWith(prefix));
}

function AppContent() {
  const { user, clearUser, updateUser } = useUser();
  const navigate = useNavigate();
  const showFooter = useShowFooter();

  const handleLogin = (u: any) => {
    updateUser(u);
  };

  const handleLogout = () => {
    clearUser();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-neutral-light overflow-x-hidden w-full max-w-full flex flex-col font-sans antialiased">
      <Header user={user} />

      {/* Контент */}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/simulator" element={<div className="mt-[var(--header-height)] h-[calc(100vh-var(--header-height))] overflow-hidden overflow-x-hidden flex flex-col w-full max-w-full"><TaskList user={user} /></div>} />
          <Route path="/task/:id" element={<div className="fixed inset-x-0 top-[var(--header-height,4.5rem)] bottom-0 overflow-hidden overflow-x-hidden flex flex-col bg-neutral-light w-full max-w-full"><Simulator user={user} /></div>} />
          <Route path="/sandbox" element={<Sandbox user={user} />} />
          <Route path="/profile" element={<div className="pt-24"><Profile user={user} onLogout={handleLogout} /></div>} />
          <Route path="/login" element={<div className="pt-24"><Login user={user} onLogin={handleLogin} /></div>} />
          <Route path="/courses" element={<div className="pt-24"><Courses user={user} /></div>} />
          <Route path="/faq" element={<div className="mt-[var(--header-height,4.5rem)]"><FAQ /></div>} />
          <Route path="/faq/:sectionId" element={<div className="mt-[var(--header-height,4.5rem)]"><FAQ /></div>} />
          <Route path="/faq/:sectionId/:questionId" element={<div className="mt-[var(--header-height,4.5rem)]"><FAQ /></div>} />
          <Route path="/telegram-auth" element={<TelegramAuth onLogin={handleLogin} />} />
          <Route path="/auth/yandex/callback" element={<YandexAuthCallback onLogin={handleLogin} />} />
          <Route path="/courses/preview/:slug" element={<div className="mt-[var(--header-height)] min-h-[calc(100vh-var(--header-height))] flex flex-col w-full"><CoursePreviewPage /></div>} />
          <Route path="/corporate" element={<div className="mt-[var(--header-height)] min-h-[calc(100vh-var(--header-height))] flex flex-col w-full"><CorporatePage /></div>} />
          <Route path="/consulting" element={<div className="mt-[var(--header-height)] min-h-[calc(100vh-var(--header-height))] flex flex-col w-full"><ConsultingPage /></div>} />
          <Route path="/courses/:slug" element={<div className="mt-[var(--header-height)] h-[calc(100vh-var(--header-height))] overflow-hidden overflow-x-hidden flex flex-col w-full max-w-full"><CoursePage user={user} /></div>} />
          <Route path="/courses/:slug/:lessonId" element={<div className="mt-[var(--header-height)] h-[calc(100vh-var(--header-height))] overflow-hidden overflow-x-hidden flex flex-col w-full max-w-full"><LessonPage user={user} /></div>} />
          <Route path="/docs" element={<div className="pt-24"><DataDocs user={user} /></div>} />
          <Route path="/job-market" element={<JobMarket user={user} />} />
          <Route path="/ai-tutor" element={<AITutor user={user} />} />
          <Route path="/ai-tutor/validate" element={<AITutorValidate />} />
          <Route path="/privacy" element={<div className="pt-24 pb-16"><PrivacyPolicy /></div>} />
          <Route path="/terms" element={<div className="pt-24 pb-16"><TermsOfService /></div>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      {showFooter && <Footer />}
      <CookieBanner />
    </div>
  );
}

function App() {
  return (
    <UserProvider>
      <AppContent />
    </UserProvider>
  );
}

export default App;
